<span class="document-extension">
  <svg class="svg-24"><use attr.xlink:href="#icon-{{ this.docIcon }}"></use></svg>
</span>
